import { render, staticRenderFns } from "./wxcrmindex.vue?vue&type=template&id=375244d9"
import script from "./wxcrmindex.vue?vue&type=script&lang=js"
export * from "./wxcrmindex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports